export { default as closeFlexPane } from './flexpanes/closeFlexPane';
export { default as setSearchActive } from './theme/setSearchActive';
//# sourceMappingURL=index.js.map